<template>
<div>
  <v-row no-gutters>
    <v-col :cols="colsMain">

      <v-row class="mgmt-panel">
      <Breadcrumbs :breadcrumbs="breadcrumbs" />

      <v-spacer></v-spacer>
      <MgmtButtons
        :view="view"
        :acl="acl"
        :system="item.system"
        @createItem="createItem"
        @deleteItem="deleteItem"
        @toView="toView"
        @toEdit="toEdit"
      />
      </v-row>
      <hr />

      <StaticTabs :selected="activeTab" light class="elevation-0">
        <v-tab href="#info" @click="activeTab = 'info'">Инфо</v-tab>
        <v-tab href="#system" @click="activeTab = 'system'">Системные</v-tab>

        <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="info">
          <v-row no-gutters class="tab-row">
            <v-col :cols="cols13">
              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-title class="primary--text">Информация</v-card-title>
                <v-card-text>
                  <table class="view-table" width="100%" >
                    <tr>
                      <th>Название:</th>
                      <td>{{ item.name }}</td>
                    </tr>
                  </table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="system">
          <v-row no-gutters class="tab-row">
            <v-col :cols="cols125">
              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-text>
                  <table class="view-table">
                    <tr>
                      <th>Создан:</th>
                      <td>{{ item.created_by_name }}</td>
                    </tr>
                    <tr>
                      <th>Дата создания:</th>
                      <td>{{ item.date_created }}</td>
                    </tr>
                    <tr>
                      <th>Изменен:</th>
                      <td>{{ item.modified_by_name || '---' }}</td>
                    </tr>
                    <tr>
                      <th>Дата изменения:</th>
                      <td>{{ item.date_modified || '---' }}</td>
                    </tr>
                  </table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </StaticTabs>
    </v-col>

    <v-col :cols="colsBar">
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <RefFilter
          class="user-filter"
          :query="initialQuery"
          :count="count"
          :filterPending="filterPending"
          :countTotal="countTotal"
          @filteredLoad="filteredLoadCollbar"
        />

      </v-row>
      <hr />
      <CollectionBar
        :id="item.id"
        :items="coll"
        :count="count"
        :loading="loadingCollbar"
        :scrollBusy="scrollBusy"
        @loadCollbar="loadCollbar"
        @toEdit="toEdit"
        @toView="toView"
      />
    </v-col>

  </v-row>
  <Confirmation
    :opened="confirmation.opened"
    :title="confirmation.title"
    :text="confirmation.text"
    :pendingSave="confirmation.pendingSave"
    @confirm="confirmConfirmationAction"
    @cancel="cancelConfirmationAction"
  />
</div>
</template>

<script>
import RefFilter from '@/components/filters/RefFilter'
import ViewMixin from '@/views/View.vue'
export default {
  mixins: [ViewMixin],
  components: {
    RefFilter
  },
  computed: {
  },
  data: function () {
    return {
      modelName: 'RefPurchaseMethod',
      viewName: 'purchase_method',
      viewTitle: 'Способ размещения закупки',

      urlList: 'ref/purchase_methods/',
      urlObj: 'ref/purchase_method/',

      parentHref: '#/ref/ref_tendercenter/purchase_method',

      // item
      item: {
        id: this.id,
        name: ''
      },
      // collbar
      collbar: {
        url: 'ref/purchase_methods/',
        name: 'purchase_method'
      },
    }
  }
}
</script>
<style>
</style>
